import {Component, Input, OnInit} from '@angular/core';
import {Lesson} from '../models/lesson.model';
import {CourseSection} from '../models/course-section.model';
import {Course} from '../models/course.model';
import {LessonsListComponent} from '../lessons-list/lessons-list.component';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'course-content',
    templateUrl: './course-content.component.html',
    styleUrls: ['./course-content.component.scss'],
    standalone: true,
    imports: [NgFor, MatExpansionModule, NgIf, MatIconModule, LessonsListComponent]
})
export class CourseContentComponent implements OnInit {

  @Input()
  playlistMode = false;

  @Input()
  course: Course;

  @Input()
  sections: CourseSection[];

  @Input()
  lessonsWatched:string[] = [];

  @Input()
  activeLesson: Lesson;

  @Input()
  sectionsLessons: {[key:string]: {sectionLessons: Lesson[], sectionStartIndex:number}} = {};


  constructor() {}

  ngOnInit() {

  }

  calculateSectionLength(section:CourseSection) {
    return this.sectionsLessons[section.id].sectionLessons.length;
  }


  calculateLessonsCompleted(section:CourseSection) {

    if (!this.sectionsLessons[section.id] || !this.lessonsWatched) {
      return 0;
    }

    const sectionLessonIds = this.sectionsLessons[section.id].sectionLessons.map(lesson => lesson.id);

    let counter = 0;

    sectionLessonIds.forEach(lessonId => {
      if (this.lessonsWatched.includes(lessonId)) {
        counter += 1;
      }
    });

    return counter;

  }


}
